import { formatDateTime, getCurrentYear } from "./helper";
import { fbiApplicantRightsLink, fbiPrivacyActLink, fbiApplicantRightsLinkText, fbiPrivacyActLinkText } from "./links";

export const instructionsMessage = () => "You will be sent an email with a QR code and further instructions, simply present the QR code to your selected location and they will capture your fingerprints and transmit them electronically.";
export const locationTitle = () => "Selected Location:";
export const hoursOfOperationTitle = () => "Hours of Operation:";
export const appointmentConfirmedMessage = (bookingDay, bookingTime) => `Your appointment confirmed at ${bookingDay}, ${bookingTime}`;
export const confirmationNumberMessage = (bookingNumber) => `Confirmation Number: ${bookingNumber}`;
export const scheduleAppointmentMessage = () => "Now it's time to schedule an appointment at selected location.";
export const paperEducationPolicyMessage = () => `Biometric Information Security Policy`
export const paperEducationLabel_1 =()=>`I confirm that I have reviewed and signed the `
export const paperEducationLabel_2 =()=>`through Paper.`
export const additionalCopiesFeeLabel = (fee = 0) => `$ ${fee} for each copy` 
export const underRetrialOrderMessage = () => `We are in the process of creating your order, we will send an order confirmation to your email shortly.`;
export const confirmationOrderPdfName = (firstName, lastName) => `${firstName}-${lastName}_${formatDateTime(new Date())}`;
export const downloadOrderPdfSuccessMessage = () => `Your order confirmation pdf is downloaded successfully`
export const fingerprintCopiesMessage = () => ` Includes one fingerprint card that will be mailed to you via USPS `
export const dontHaveSSN = () => ` I don't have a Social Security Number `
export const actStatementMesssage = (text) => {
    switch (text) {
        case 'paragraphOne':
            return `Your fingerprints are submitted to the FBI for the purpose of obtaining a copy of your FBI Identity History Summary. This background check is for personal review or noncriminal justice purposes, such as employment, licensing, or immigration.`

        case 'paragraphTwo':
            return `By proceeding, you acknowledge:`
        
        case 'listOne':
            return `You are submitting your own fingerprints voluntarily.`
        
        case 'listTwo':
            return `The results of your background check will be made available to you securely through an online portal.`
        
        case 'listThree':
            return `You have the right to challenge or correct the information in your report by following the procedures in the `
        
        case 'listFour':
            return `If you believe your personally identifiable information (PII) has been mishandled, you have the right to report a breach directly to the FBI. Instructions are available in the `
        
        case 'fbiApplicantRightsLink':
            return fbiApplicantRightsLink()
        
        case 'fbiApplicantRightsLinkText':
            return fbiApplicantRightsLinkText()
        
         case 'fbiPrivacyActLink':
            return fbiPrivacyActLink() 

        case 'fbiPrivacyActLinkText':
            return fbiPrivacyActLinkText()
        
        default:
            break;
    }
};
export const disclaimerMessages = (paragraph) => {
    switch (paragraph) {
        case 'paragraphOne':
            return `Your FBI background check is securely processed, and the results will be delivered to you either through a secure online portal or by postal mail, depending on the delivery method you select. Certifix does not access or deliver your report directly.`

        case 'paragraphTwo':
            return `Please review your results carefully. If you believe your record contains errors, you have the right to challenge or correct the information. For more details, refer to the`

        case 'paragraphThree':
            return `If you suspect your personal data has been mishandled, you may report a potential privacy breach directly to the FBI. Instructions are available in the`
        
        case 'fbiApplicantRightsLink':
            return fbiApplicantRightsLink()
        
        case 'fbiApplicantRightsLinkText':
            return fbiApplicantRightsLinkText()

        case 'fbiPrivacyActLink':
            return fbiPrivacyActLink() 
    
        case 'fbiPrivacyActLinkText':
            return fbiPrivacyActLinkText()

        default:
            return "";
    }
}


export const disclaimerAcknowledgement = () => `By checking this box, I confirm that I have read and understood the above information, and I consent to the submission of my fingerprints for an FBI background check. I understand that results will be provided through a secure online portal or mailed to me, and that I have the right to review or challenge my report.`
export const isUSCitizenLabel = () => `Are You U.S Citizen Or Legal Permanent Resident?`
export const serviceSelectionParagraphs = (paragraph) => {
    switch (paragraph) {
        case 'paragraphOne':
            return `We will scan your fingerprints and`
        case 'paragraphTwo':
            return `electronically transmit them to`
        case 'paragraphThree':
            return `FDLE or AHCA.`
        default:
            return ``
    }
} 
export const mailCodePlaceHolder = () => `e.g 12345`;
export const certifixPhone = () =>'(800) 710 1934 ';
export const certifixPhoneWithCountryCode = () =>'1 (800) 710 1934 ';
export const supportEmail = () => 'support@certifixlivescan.com ';
export const homeBreadCrumbsMessage = () => 'Go to Certifix Live Scan.';
export const servicesBreadCrumbsMessage = () => 'Go to Certifix Live Services.';
export const rightsReservedMessage = () => `${getCurrentYear()} Certifix Inc. All Rights Reserved.`;
export const fdleRedirectionModalText = (paragraph) => {
    switch (paragraph) {
        case "paragraphOne":
            return "You are currently using a "
        case "boldText":
            return "Florida-based ORI "
        case "paragraphTwo":
            return "number for a Live Scan submission. However, you're enrolling for a Fingerprint Card Service."
        default:
            return ""
    }
}
export const emailDeliveryNoteMessage = (paragraph) => {
    switch(paragraph){
        case "paragraphOne":
            return `Note: If you do not receive an email, please make sure to check your `;
        case "boldText": 
            return `spam `;
        case "paragraphTwo": 
            return `folder.`;
        default: 
            return ""
    }
}
export const requestOriModalText = () => `If you're unable to find your ORI number or believe the one you entered should be included in our online enrollment system, please provide the details below. Our team will review your request and update the system as needed.`;
export const requestOriBlankMessage = (paragraph) =>  {
    switch(paragraph){
        case "paragraphOne":
            return `If you don’t know your ORI number, check with your requesting agency or `;
        case "span":
            return `click here `;
        case "paragraphTwo":
            return `to request its addition to our online enrollment system.`;
        default:
            return ""
    }
}
export const requestOriInvalidMessage = (paragraph) => {
    switch(paragraph){
        case "boldText":
            return `The ORI number entered is invalid.`
        case "paragraphOne":
            return `Verify your ORI number with your requesting agency. If it needs to be added to our online enrollment system, `;
        case "span":
            return `click here `;
        case "paragraphTwo":
            return `to request it.`;
        default:
            return ""
    }
}
export const requestOriSuccessMessage = () => `Request has been submitted successfully.`;
export const notAllowedServiceMessage = (paragraph) => {
    switch(paragraph){
        case "boldText":
            return `Service Not Available with Your Account`
        case "paragraphOne":
            return `The selected service isn’t supported by your current Certifix account. Please choose another service or contact support if you need assistance.`
        default:
            return ""
    }
}
export const noServicesAvailableMessage = (message) =>{
    switch(message){
        case "messageOne":
            return `No Services Available`
        case "messageTwo":
            return `There are no services associated with the account you selected.`
        case "messageThree":
            return `Please contact Certifix support at `
        case "messageFour":
            return `for further assistance.`
        default:
            return ""
    }
}